import { format } from 'date-fns'
import { SquareAsterisk } from 'lucide-react'
import { Muted } from '@/components/sv/typographies'
import { registryMap } from '@/routes/registry-credentials/utils/registry-map'
import type { DockerRegistry } from '@/graphql.types'
import type { Row } from '@/routes/registry-credentials/registry-credentials-table/types'
import type { CellContext } from '@tanstack/react-table'

export const NameCell = ({ row }: CellContext<Row, unknown>) => {
  const name: string = row.getValue('name') ?? ''
  return (
    <div className="py-3 px-4 flex items-center gap-2 font-medium">
      <SquareAsterisk className="size-4 min-w-4" />
      <span
        title={name}
        className="block max-w-[400px] overflow-ellipsis whitespace-nowrap overflow-hidden"
      >
        {name}
      </span>
    </div>
  )
}

export const RegistryCell = ({ row }: CellContext<Row, unknown>) => {
  const registry: string = row.getValue('registry') ?? ''
  const RegistryLogo = registryMap[registry as DockerRegistry]?.logo
  const title = registryMap[registry as DockerRegistry]?.title

  return (
    <Muted className="px-2 flex items-center gap-2">
      {RegistryLogo ? <RegistryLogo className="size-4" /> : null}
      {title}
    </Muted>
  )
}

export const CreatedAtCell = ({ row }: CellContext<Row, unknown>) => {
  return (
    <Muted className="px-2">
      {format(new Date(row.original.createdAt), 'MMM d, yyyy')}
    </Muted>
  )
}
